import 'antd/dist/antd.css'
import React from 'react'
import styles from './styles.module.css'
import Head from './modules/head'
import Operation from './modules/operation'
import UploadEl from './modules/upload'
import BottomEl from './modules/bottom'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/lib/locale/zh_CN'

export const ZhylCkdComputablePhenotypeTool = (props) => {
  const { templatePath = '/file/template.xlsx' } = props
  return (
    <ConfigProvider locale={zhCN}>
      <div className={styles.zhyl_ckd_wrap}>
        <Head />
        <Operation />
        <UploadEl templatePath={templatePath} />
        <BottomEl />
      </div>
    </ConfigProvider>
  )
}
